const fetchEquip = {
  text: 'Ningún resultado encontrado'
}

export default fetchEquip;
